var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-background",class:{hidden: !_vm.loading}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/icons/Allhouse_LoadingGIF (1).gif")}}),_c('h5',[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }